"use client";

import { forwardRef, useState } from "react";

import type { TextProps } from "../../../_base/_core/Text/Text";
import { Text } from "../../../_base/_core/Text/Text";

export type ExpandableTextProps = TextProps & {};

export const ExpandableText = forwardRef<any, ExpandableTextProps>(
  ({ lineClamp, overflow, ...props }, ref) => {
    const [expanded, setExpanded] = useState<boolean>(false);

    const handleOnClick = () => setExpanded(!expanded);

    return (
      <Text
        lineClamp={expanded ? null : lineClamp}
        onClick={handleOnClick}
        overflow={expanded ? null : overflow}
        ref={ref}
        {...props}
      />
    );
  },
);

ExpandableText.displayName = "ExpandableText";
